export default "__VITE_ASSET__Bl3HEJ_Y__"